import { useEffect } from 'react'
import { useRoutes, useNavigate, type NavigateFunction } from 'react-router-dom'
import routes from './config'

let navigateResolver: (navigate: NavigateFunction) => void

declare global {
  interface Window {
    REACT_APP_NAVIGATE: NavigateFunction
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve
})

export function AppRoutes() {
  const element = useRoutes(routes)
  const navigate = useNavigate()

  useEffect(() => {
    if (!window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE = navigate
      navigateResolver(navigate)
    }
  }, [navigate])

  return element
}